import { useMemo } from "react"

export const usePreview = (file: File | null)=>{
  return useMemo(() => file && URL.createObjectURL(file), [file])
}